<template>
  <div
    class="details-table-right"
    :class="{
      'details-table-right--align-center': alignCenter,
      'details-table-right--mobile-align-center': mobileAlignCenter,
      'details-table-right--auto-height': autoHeight,
      'details-table-right--preserve-whitespace': preserveWhitespace,
      'details-table-right--disabled': disabled,
      'details-table-right--mobile': isMobileView,
    }"
    :style="style"
  >
    <tm-skeleton
      v-if="loading"
      type="QChip"
      random-width
      height="12px"
    />

    <slot v-else>
      {{ value || '-' }}
    </slot>
  </div>
</template>

<script setup lang="ts">
import { computed, type StyleValue } from '@/composition/vue/compositionApi'
import TmSkeleton from '@/components/shared/skeletons/TmSkeleton.vue'

const props = defineProps<{
  value?: string | null
  alignCenter?: boolean
  mobileAlignCenter?: boolean
  preserveWhitespace?: boolean
  autoHeight?: boolean
  disabled?: boolean
  loading?: boolean
  isMobileView: boolean
  paddingY?: string
}>()

const style = computed<StyleValue>(() => {
  if (!props.paddingY) {
    return {}
  }

  return {
    paddingTop: props.paddingY,
    paddingBottom: props.paddingY,
  } satisfies Partial<CSSStyleDeclaration>
})
</script>

<style lang="scss" scoped>
.details-table-right {
  width: 100%;
  overflow: hidden;
  padding: 0 16px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  word-break: break-word;

  &--align-center {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  &--auto-height {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  &--preserve-whitespace {
    white-space: pre-wrap;
  }

  &--disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &--mobile {
    padding: 0 12px 12px;

    &.details-table-right--mobile-align-center {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      padding: 12px;
    }
  }
}
</style>
